import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useMemo, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import styled from 'styled-components';
import i18n from 'i18n';
import { setAlert } from 'actions/alerts';
import { FILE_STATUS_VALUES } from 'actions/file';
import { assetQueryKeys } from 'actions/assets';
import { playlistQueryKeys } from 'actions/playlists';
import { fillParent } from 'styles/mixins';
import createUrl from 'tricks/string/createUrl';
import { redirectToLogin } from 'utils/auth/getLogoutPath';
import getEmbeddedVideo from 'utils/getEmbeddedVideo';
import logoutUser from 'utils/auth/logout';
import { getSessionToken } from 'utils/track';
import { getAssetIcon } from 'utils/icons';
import { TYPE_ZIP } from 'utils/file';
import ImageViewer from 'components/ImageViewer';
import AudioPlayer from 'components/AudioPlayer';
import ExternalLinkPanel from './ExternalLinkPanel';
import DirectDownloadLink from './DirectDownload';
import AudioPlayerWrapper from './AudioPlayerWrapper';
import BrightcovePlayer from './BrightcovePlayer';
import WebVideoPlayer from './WebVideoPlayer';
import PDFViewer from './PDFViewer';
import AutoCompleteWrapper from '../AutoCompleteWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
var Iframe = styled.iframe.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'onComplete';
  }
}).withConfig({
  displayName: "Content__Iframe",
  componentId: "sc-fze4n1-0"
})(["", " width:100%;height:100%;"], fillParent);
function handlePostScormSave(_x) {
  return _handlePostScormSave.apply(this, arguments);
}
function _handlePostScormSave() {
  _handlePostScormSave = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var assetId, playlistId, status, queryClient, setAuthUser, _t2;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          assetId = _ref.assetId, playlistId = _ref.playlistId, status = _ref.status, queryClient = _ref.queryClient, setAuthUser = _ref.setAuthUser;
          if (status === 200) {
            queryClient.invalidateQueries({
              queryKey: assetQueryKeys.singleAsset(assetId)
            });
            if (playlistId) {
              queryClient.invalidateQueries({
                queryKey: playlistQueryKeys.mySinglePlaylistContent(playlistId)
              });
              queryClient.invalidateQueries({
                queryKey: playlistQueryKeys.mySinglePlaylistDetails(playlistId)
              });
            }
          }
          if (!(status === 401)) {
            _context2.next = 4;
            break;
          }
          _context2.prev = 1;
          _context2.next = 2;
          return logoutUser();
        case 2:
          setAuthUser(null);
          redirectToLogin();
          _context2.next = 4;
          break;
        case 3:
          _context2.prev = 3;
          _t2 = _context2["catch"](1);
          if (_t2 !== null && _t2 !== void 0 && _t2.error) {
            setAlert({
              title: i18n.t('alert_logout_failed')
            });
          }
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 3]]);
  }));
  return _handlePostScormSave.apply(this, arguments);
}
function AssetViewerContent(props) {
  var iframe = useRef(null);
  var queryClient = useQueryClient();
  var asset = props.asset,
    downloadUrl = props.downloadUrl,
    autoCompleteEnabled = props.autoCompleteEnabled,
    onLoad = props.onLoad,
    onError = props.onError,
    onComplete = props.onComplete,
    setAuthUser = props.setAuthUser,
    markIframeContentAsLoaded = props.markIframeContentAsLoaded,
    playlistId = props.playlistId;
  var download = asset.download,
    fileFormat = asset.fileFormat,
    type = asset.type,
    locale = asset.locale;
  useEffect(function () {
    function handlePostMessage(_x2) {
      return _handlePostMessage.apply(this, arguments);
    }
    function _handlePostMessage() {
      _handlePostMessage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var _event$data;
        var payload, _ref2, status, _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _t = event === null || event === void 0 || (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.type;
              _context.next = _t === 'scorm-player:post-save' ? 1 : _t === 'scorm-player:content-loaded' ? 3 : 4;
              break;
            case 1:
              payload = event.data.payload;
              _ref2 = payload || {}, status = _ref2.status;
              _context.next = 2;
              return handlePostScormSave({
                queryClient: queryClient,
                assetId: asset.id,
                playlistId: playlistId,
                status: status,
                setAuthUser: setAuthUser
              });
            case 2:
              return _context.abrupt("continue", 4);
            case 3:
              markIframeContentAsLoaded();
              return _context.abrupt("continue", 4);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _handlePostMessage.apply(this, arguments);
    }
    window.addEventListener('message', handlePostMessage, false);
    // return a function to execute at unmount
    return function () {
      window.removeEventListener('message', handlePostMessage, false);
    };
  }, [asset.id, markIframeContentAsLoaded, playlistId, queryClient, setAuthUser]);
  function getScormOptions(asset) {
    var collectionPostfix = playlistId && !isNaN(playlistId) ? "/collections/".concat(playlistId) : '';
    var baseUrl = "".concat(window.location.origin, "/api/scorm/assets/").concat(asset.id).concat(collectionPostfix);
    var userId = localStorage.getItem('id');
    return {
      sessionToken: getSessionToken(),
      baseUrl: baseUrl,
      pmo: i18n.t('scorm_message_after_open_popup'),
      pmf: i18n.t('scorm_message_when_cannot_open_popup'),
      userId: userId
    };
  }
  var assetIcon = getAssetIcon(asset);
  var directDownload = download === 'required';
  var handlers = {
    onLoad: onLoad,
    onError: onError,
    onComplete: onComplete
  };
  var assetUrl = asset.convertedUrl || asset.webUrl;
  // Download-only assets are allowed to render even if the file is invalid.
  // We compute this once and use it to gate all blocking error paths below.
  var isDirectDownloadAsset = directDownload && Boolean(downloadUrl) && type !== 'web';

  // Centralize asset blocking checks in one memoized value so
  // onError is emitted from effects instead of during render.
  var blockingAssetError = useMemo(function () {
    if (isDirectDownloadAsset) {
      return null;
    }
    if (asset.fileStatus === FILE_STATUS_VALUES.PROCESSING) {
      return {
        key: 'processing',
        icon: 'link',
        message: i18n.t('asset_viewer_error_processing')
      };
    }
    if (asset.fileStatus === FILE_STATUS_VALUES.INVALID) {
      if ((asset === null || asset === void 0 ? void 0 : asset.uploadErrorCode) === 'INVALID_ASSET_TYPE_ERROR') {
        return {
          key: 'invalid-asset-type',
          icon: 'link',
          message: i18n.t('asset_viewer_error_invalid')
        };
      }
      if (asset.fileFormat === 'video') {
        return {
          key: 'invalid-video',
          icon: 'link',
          message: i18n.t('asset_viewer_error_video')
        };
      }
      return {
        key: 'invalid-processing-issue',
        icon: 'link',
        message: i18n.t('asset_viewer_error_processing_issue')
      };
    }
    if (!assetUrl) {
      return {
        key: 'missing-asset-url',
        icon: 'link',
        message: i18n.t('asset_viewer_error_visible')
      };
    }
    return null;
  }, [asset.fileFormat, asset.fileStatus, asset.uploadErrorCode, assetUrl, isDirectDownloadAsset]);

  // Keep side effects out of render: when a blocking condition is detected,
  // notify the parent wrapper so it can show the corresponding error state.
  useEffect(function () {
    if (blockingAssetError) {
      onError({
        icon: blockingAssetError.icon,
        message: blockingAssetError.message
      });
    }
  }, [blockingAssetError, onError]);
  var assetContent;
  var assetType = ['web', 'scorm', TYPE_ZIP].includes(asset.type) ? asset.type : null;
  if (!assetType) {
    var isPdf = asset.convertedFileType === 'pdf' && asset.converted;
    assetType = isPdf ? 'pdf' : fileFormat || type;
  }

  // Video-unavailable is handled separately from generic blocking errors because
  // it depends on the derived assetType, and it should not trigger for download-only assets.
  var unavailableVideoError = useMemo(function () {
    return !isDirectDownloadAsset && assetType === 'video' && !asset.brightcoveAccountId ? {
      key: 'video-unavailable',
      icon: 'link',
      message: i18n.t('asset_viewer_error_video_unavailable')
    } : null;
  }, [assetType, asset.brightcoveAccountId, isDirectDownloadAsset]);

  // Emit video-specific errors from an effect for the same render-purity reason
  // as blockingAssetError above.
  useEffect(function () {
    if (unavailableVideoError) {
      onError({
        icon: unavailableVideoError.icon,
        message: unavailableVideoError.message
      });
    }
  }, [onError, unavailableVideoError]);
  if (!asset.id) return null;
  var directDownloadUrl = downloadUrl;

  // This early return must happen before any null-on-error return below, otherwise
  // download-only invalid assets would lose their download action.
  // We need to explicitly typecheck here unfortunately, as the database disableDownload field is not 0 for all web links.
  if (directDownload && directDownloadUrl && type !== 'web') {
    return /*#__PURE__*/_jsx(DirectDownloadLink, _objectSpread({
      asset: asset,
      link: directDownloadUrl,
      autoCompleteEnabled: autoCompleteEnabled
    }, handlers));
  }
  if (blockingAssetError) {
    return null;
  }
  if (unavailableVideoError) {
    return null;
  }
  if (!assetUrl) {
    return null;
  }
  var withAutoComplete = function withAutoComplete(component) {
    return /*#__PURE__*/_jsx(AutoCompleteWrapper, {
      autoCompleteEnabled: autoCompleteEnabled,
      userContentStatus: asset.userContentStatus,
      onComplete: onComplete,
      children: component
    });
  };
  switch (assetType) {
    case 'pdf':
      {
        assetContent = withAutoComplete(/*#__PURE__*/_jsx(PDFViewer, _objectSpread({
          src: assetUrl,
          title: asset.name
        }, handlers)));
        break;
      }
    case 'image':
      {
        assetContent = withAutoComplete(/*#__PURE__*/_jsx(ImageViewer, _objectSpread({
          imageUrl: assetUrl,
          alternativeText: asset.alternativeText
        }, handlers)));
        break;
      }
    case 'audio':
      {
        assetContent = /*#__PURE__*/_jsx(AudioPlayerWrapper, {
          icon: assetIcon,
          pictureUrl: asset.pictureUrl,
          children: /*#__PURE__*/_jsx(AudioPlayer, _objectSpread({
            url: assetUrl,
            locale: locale,
            autoCompleteEnabled: autoCompleteEnabled,
            userContentStatus: asset.userContentStatus
          }, handlers))
        });
        break;
      }
    case 'video':
      {
        var brightcoveAccountId = asset.brightcoveAccountId;
        if (!brightcoveAccountId) {
          return null;
        }
        assetContent = /*#__PURE__*/_jsx(BrightcovePlayer, _objectSpread({
          accountId: brightcoveAccountId,
          videoId: asset.brightcoveVideoId,
          userContentStatus: asset.userContentStatus,
          autoCompleteEnabled: autoCompleteEnabled
        }, handlers), "video-".concat(brightcoveAccountId, "-").concat(asset.brightcoveVideoId));
        break;
      }
    default:
      {
        // This was a part of a routing system to attach additional parameters to the URL.
        var src;
        if (assetType === 'web') {
          src = "/api/url?url=".concat(encodeURIComponent(assetUrl));
        } else if (assetType === 'scorm') {
          src = createUrl(assetUrl, getScormOptions(asset));
        } else if (assetType === TYPE_ZIP) {
          // Microsite
          // Include the hash in the source URL
          src = "".concat(assetUrl).concat(window.location.hash);
        } else {
          src = assetUrl;
        }

        // Scorm player controls displaying content in popup/iframe via its own settings called 'openContentIn'
        // Force insecure web links to open in a new window
        var openAsExternalLink = asset.openInIframe ? assetType === 'web' && !assetUrl.toLowerCase().startsWith('https://') : assetType !== 'scorm';
        if (openAsExternalLink) {
          assetContent = /*#__PURE__*/_jsx(ExternalLinkPanel, _objectSpread({
            asset: asset,
            link: src,
            autoCompleteEnabled: autoCompleteEnabled
          }, handlers));
        } else {
          var embeddedVideoUrl = getEmbeddedVideo(assetUrl);

          // Use the web video player if the video is hosted in one of the supported video hosts
          if (embeddedVideoUrl) {
            assetContent = /*#__PURE__*/_jsx(WebVideoPlayer, _objectSpread({
              src: embeddedVideoUrl,
              userContentStatus: asset.userContentStatus,
              autoCompleteEnabled: autoCompleteEnabled
            }, handlers), "web-video-".concat(asset.id));
          } else {
            assetContent = /*#__PURE__*/_jsx(Iframe, _objectSpread({
              ref: iframe,
              src: src,
              title: asset.name,
              allow: "camera *; microphone *; autoplay *"
            }, handlers));
            if (assetType !== 'scorm') {
              assetContent = withAutoComplete(assetContent);
            }
          }
        }
        break;
      }
  }
  return assetContent;
}
export default AssetViewerContent;